import { translate } from 'components/Translation';
import React from 'react';
import apiConfig from 'utils/api/config';

const Logo = () => {
	return (
		<a
			href={apiConfig.links.businessLink}
			target="_blank"
			rel="noopener noreferrer"
			aria-label={translate('nav.logo')}
		>
			<img src="/logo-color.svg" width={100} alt="" role="presentation" />
		</a>
	);
};

export default Logo;
